import { UserContext, IUserContext, useThemeContext } from 'contexts';
import { useContext, useMemo } from 'react';
import { CountryCodeList } from 'types/countries';
import { ThemeNames } from 'types/themes';

export const useListingRestrictions = (isCanadianListing = true) => {
  const { userLocation, siteLocation } = useContext(UserContext) as IUserContext;
  const { themeName } = useThemeContext();
  
  const canViewSchools = useMemo(() => {
    if (isCanadianListing) {
      if (siteLocation!==CountryCodeList.CANADA) return false; 
      if (userLocation?.countryCode!==CountryCodeList.CANADA) return false;
      if (themeName===ThemeNames.EXP_REALTY_US) return false;      
    }
    return true;
  }, [isCanadianListing, siteLocation, userLocation, themeName]);
    
  return { canViewSchools };
};